import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(site)/blog/page.tsx");
